<template>
    <div class="de-link-wrapper">
        <a class="link" 
        v-for="(item,index) in links" 
        :key="index" 
        :href="item.link"
        :style="linkStyle">{{item.name}}</a>
    </div>
</template>

<script>
export default {
    name: 'de-link',
    props: {
        links: {
            type: [Array,Object],
            default: () => {
                return [];
            }
        },
        fontObj: {
            type: Object
        },
        width: {
            type: Number
        }
    },
    computed: {
        linkStyle(v) {
            return this.fontObj
            ? Object.assign({}, this.fontObj, {
                fontSize: `${this.fontObj.fontSize}px`,
                width: `${this.width}px`
            })
            : {};
        }
    }
}
</script>

<style lang="less">
.de-link-wrapper {
    display: flex;
    flex-wrap: wrap;
    .link {
        color: #ccc;
        display: inline-block;
        width: 100px;
        text-decoration: none;
    }
}
</style>